// extracted by mini-css-extract-plugin
export var active = "_eh-2";
export var recordingDot = "_eh-1";
export var recordingIndicator = "_eh-0";